<template>
  <div class="solution_fttx">
    <!-- 顶部大图横幅 -->
    <div
        class="top_img"
        :style="{
        'background-image': `url(${solutionData.topImage || require('../../static/img/new_top_bg.png')})`
      }"
    >
      <p class="title">{{ topTitle }}</p>
      <p class="subtitle">{{ topIntro }}</p>
    </div>

    <!-- 面包屑导航 -->
    <div class="nav_container">
      <div class="breadcrumb_section">
        <div class="breadcrumb_content">
          <span @click="$router.push('/')">{{ $t("Home") }}</span>
          <span class="separator">></span>
          <span class="current">{{ $t("FTTx") }}</span>
        </div>
      </div>
      <div class="page_nav_div">
        <p class="active">{{ $t("FTTx") }}</p>
        <p @click="goToSolution('DataCenter')">{{ $t("Data Center") }}</p>
        <p @click="goToSolution('Customized')">{{ $t("Customized") }}</p>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main_content">
      <p class="section_title">{{ $t("FTTx Solution") }}</p>
      <div class="content_wrapper">
        <!-- 左侧产品列表 -->
        <div class="left_sidebar">
          <div class="product_list">
            <div class="product_item" v-for="(item, index) in productList" :key="index">
              <div class="item_header" @click="toggleItem(index)">
                <span class="product_title">{{ item.title }}</span>
                <i v-if="item.children && item.children.length > 0 && !item.expanded" class="el-icon-plus"></i>
                <i v-else-if="item.children && item.children.length > 0 && item.expanded" class="el-icon-minus"></i>
              </div>
              <div class="item_content" v-show="item.expanded">
                <div class="sub_item" v-for="(sub, subIndex) in item.children" :key="subIndex"
                     @click="goToSubItem(sub)">
                  <div class="sub_img">
                    <img :src="sub.image">
                  </div>
                  <div class="sub_info">
                    <span class="sub_name">{{ sub.name }}</span>
                    <p class="view_btn">{{ $t("更多") }} ></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="more_link">{{ $t("更多") }}</div>
          </div>
        </div>

        <!-- 右侧图片展示区 -->
        <div class="right_content">
          <div class="image_display">
            <img v-if="solutionData.bigImage" :src="solutionData.bigImage" alt="Solution Image">

            <!-- 交互式红点 -->
            <div
                v-for="(hotspot, index) in hotspots"
                :key="index"
                class="hotspot"
                :style="{ left: hotspot.left, top: hotspot.top }"
                @mouseenter="hotspot.hasData && (activeHotspot = index)"
                @mouseleave="activeHotspot = null"
            >
              <img src="../../static/img/red_dot.png" alt="hotspot" class="hotspot_dot">

              <!-- 弹出框 - 只在有数据时显示 -->
              <div
                  v-if="activeHotspot === index && hotspot.hasData"
                  class="hotspot_popup"
                  @click="goToProductDetail(hotspot.productId)"
              >
                <img :src="hotspot.popupImage" alt="popup image" class="popup_image">
                <pre class="popup_text">{{ hotspot.popupText }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/index";
import {getProductInfo} from "@/api/index";

export default {
  data() {
    return {
      solutionData: {},
      productList: [],
      activeHotspot: null,
      hotspots: [
        {
          left: '54%',
          top: '8%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 1 - Product Feature'
        },
        {
          left: '63%',
          top: '10%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 2 - Technical Specification'
        },
        {
          left: '28%',
          top: '18%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 3 - Connection Point'
        },
        {
          left: '40%',
          top: '25%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 4 - Network Module'
        },
        {
          left: '80%',
          top: '21%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 6 - Power Supply'
        },
        {
          left: '63.5%',
          top: '28%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 7 - Control Unit'
        },
        {
          left: '57%',
          top: '36%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 9 - Optical Module'
        },
        {
          left: '32.5%',
          top: '43%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 10 - Management Interface'
        },
        {
          left: '88.5%',
          top: '36%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 8 - Data Port'
        },
        {
          left: '66.5%',
          top: '45%',
          popupImage: require('../../static/img/red_dot.png'),
          popupText: 'Hotspot 5 - Interface Detail'
        }
      ]
    };
  },
  computed: {
    topTitle() {
      if (this.$i18n.locale === 'zh') {
        return this.solutionData.topTitleCn || "";
      } else if (this.$i18n.locale === 'es') {
        return this.solutionData.topTitleEs || this.solutionData.topTitleEn || "";
      }
      return this.solutionData.topTitleEn || "";
    },
    topIntro() {
      if (this.$i18n.locale === 'zh') {
        return this.solutionData.topIntroCn || "";
      } else if (this.$i18n.locale === 'es') {
        return this.solutionData.topIntroEs || this.solutionData.topIntroEn || "";
      }
      return this.solutionData.topIntroEn || "";
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getSolutionCategoryData(1);
    this.getSolutionSubCategories();
  },
  methods: {
    // 获取解决方案分类数据
    getSolutionCategoryData(id) {
      API.getSolutionCategoryInfo(id)
          .then((res) => {
            if (res.code === 0 && res.solutionCategory) {
              this.solutionData = res.solutionCategory;
            }
          })
          .catch(() => {
          });
    },
    // 获取解决方案二级分类列表
    async getSolutionSubCategories() {
      try {
        const res = await API.getSolutionSubCategoryList({parentId: 1});
        if (res.code === 0 && res.page && res.page.list) {
          const subcategories = res.page.list;

          // 为每个二级分类获取产品分类详情
          const productListPromises = subcategories.map(async (subcategory, index) => {
            const children = [];
            const url = subcategory.url;

            // 获取该二级分类下的所有产品分类
            if (subcategory.productCategoryIds && subcategory.productCategoryIds.length > 0) {
              const categoryPromises = subcategory.productCategoryIds.map(categoryId =>
                  API.getProductCategoryInfo(categoryId)
              );

              const categoryResults = await Promise.all(categoryPromises);

              categoryResults.forEach(categoryRes => {
                if (categoryRes.code === 0 && categoryRes.productCategory) {
                  const category = categoryRes.productCategory;
                  children.push({
                    id: category.id,
                    name: this.getLocalizedTitle(category),
                    image: category.image
                  });
                }
              });
            }

            return {
              title: this.getLocalizedTitle(subcategory),
              url:url,
              expanded: false,
              children: children
            };
          });

          this.productList = await Promise.all(productListPromises);

          // 获取所有产品分类的ID
          const allCategoryIds = [];
          this.productList.forEach(item => {
            item.children.forEach(child => {
              if (child.id) {
                allCategoryIds.push(child.id);
              }
            });
          });

          // 通过产品分类ID获取产品详细数据
          await this.getProductsByCategories(this.solutionData.productIds);
        }
      } catch (error) {
        console.error('Failed to fetch solution subcategories:', error);
      }
    },
    // 通过产品分类ID获取产品详细数据并绑定到红点
    async getProductsByCategories(categoryIds) {
      try {
        const allProducts = [];

        // 为每个分类ID获取产品列表
        for (const categoryId of categoryIds) {
          const res = await API.getProductInfo(categoryId);
          if (res.code === 0 && res.product) {
            allProducts.push(res.product);
          }
        }

        // 将产品数据绑定到红点
        this.hotspots = this.hotspots.map((hotspot, index) => {
          const product = allProducts[index];
          if (product) {
            // 解析images JSON字符串，取第一张图片
            let firstImage = hotspot.popupImage;
            if (product.images) {
              try {
                const imageArray = JSON.parse(product.images);
                if (imageArray && imageArray.length > 0) {
                  firstImage = imageArray[0];
                }
              } catch (e) {
                console.error('Failed to parse product images:', e);
              }
            }

            // 根据语言获取产品名称
            let productName = '';
            if (this.$i18n.locale === 'zh') {
              productName = product.nameCn || product.nameEn || '';
            } else if (this.$i18n.locale === 'es') {
              productName = product.nameEs || product.nameEn || '';
            } else {
              productName = product.nameEn || '';
            }

            return {
              ...hotspot,
              popupImage: firstImage,
              popupText: productName.replace(";",""),
              productId: product.id,
              hasData: true
            };
          }
          return {
            ...hotspot,
            hasData: false
          };
        });
      } catch (error) {
        console.error('Failed to fetch products by categories:', error);
      }
    },
    // 根据当前语言获取标题
    getLocalizedTitle(item) {
      return this.$getI18nField(item, 'title');
    },
    getLocalizedTitle2(item) {
      return this.$getI18nField(item, 'name');
    },
    toggleItem(index) {
      if (this.productList[index].url) {
        window.location.href = this.productList[index].url;
      } else {
        this.productList[index].expanded = !this.productList[index].expanded;
      }
    },
    goToSolution(type) {
      this.$router.push(`/Solution${type}`);
    },
    // 跳转到产品详情页
    goToProductDetail(productId) {
      if (productId) {
        this.activeHotspot = null;
        this.$router.push(`/ProductsDetail/${productId}`);
      }
    },
    // 左侧子列表点击：产品分类→Products页，产品→详情页
    goToSubItem(sub) {
      if (sub.isProduct) {
        this.$router.push(`/ProductsDetail/${sub.id}`);
      } else {
        this.$router.push({path: '/Products', query: {param: sub.id}}).catch(() => {
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.solution_fttx {
  .top_img {
    padding: 0 12.5%;
    height: 47rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .title {
      text-align: left;
      font-size: 7rem;
      font-family: bold;
      color: white;
      margin: 7rem 0 0 0;
      align-self: flex-start;
    }

    .subtitle {
      width: 40%;
      text-align: left;
      font-size: 2.4rem;
      color: #E7E8EA;
      margin-top: 1rem;
    }
  }

  .breadcrumb_section {
    background: white;
    padding: 3rem 0 0;
    width: 50%;

    .breadcrumb_content {
      max-width: 140rem;
      margin: 0 auto;
      padding: 0 2rem;
      font-size: 1.8rem;
      color: #BDC0C5;
      text-align: left;
      font-family: regular;

      span {
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1d2087;
        }

        &.separator {
          margin: 0 1rem;
          color: #BDC0C5;
          cursor: default;
        }

        &.current {
          color: #1D2087;
          cursor: default;
        }
      }
    }
  }

  .nav_container {
    display: flex;
    background: white;
    border-bottom: 1px solid #BDC0C5;
    padding: 0 12.5% 0;
  }

  .main_content {
    padding: 15rem 0 30rem;

    .section_title {
      margin: 0 0 8rem 0;
      padding-left: 12.5%;
      font-size: 5rem;
      color: #212121;
      text-align: left;
    }

    .content_wrapper {
      margin: 0 12.5%;
      padding: 0;
      display: flex;
    }
  }

  .left_sidebar {
    width: 44rem;

    h2 {
      font-size: 2.4rem;
      color: $color2C;
      margin: 0 0 2rem;
    }


    .product_title {
      font-size: 2.4rem;
      color: #1D2087;
      text-align: left;
    }

    .sub_name {
      font-size: 1.8rem;
      color: #5B6370;
      font-family: medium;
      margin-bottom: 1.6rem;
      text-align: left;
    }

    .product_list {
      .product_item {
        margin-bottom: 2rem;

        .item_header {
          font-family: medium;
          padding: 0 0 0.5rem 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          font-size: 2.4rem;
          color: #1D2087;
          border-bottom: 1px solid #707070;

          i {
            color: #959AA3;
          }
        }

        .item_content {
          padding-bottom: 1rem;

          .sub_item {
            padding: 1rem 0 1rem 0;
            display: flex;
            justify-content: left;
            align-items: flex-start;
            font-size: 1.8rem;
            color: #5B6370;
            font-family: medium;
            margin-bottom: 1.6rem;
            cursor: pointer;

            .sub_info {
              margin-top: 2rem;
              margin-left: 2rem;
              display: flex;
              flex-direction: column;
            }

            .sub_img {
              width: 12rem;
              height: 12rem;
              //background: #e0e0e0;
              background-size: contain;
              background-position: center;
              border-radius: 1.6rem;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

            .view_btn {
              width: fit-content;
              background: none;
              border: 1px solid #8A9099;
              border-radius: 3rem;
              color: #8A9099;
              cursor: pointer;
              font-size: 1.6rem;
              padding: 0.5rem 1.5rem 0.2rem;
              margin-top: 0;

              &:hover {
                border: 1px solid #9CCF86;
                color: #9CCF86;
              }
            }
          }
        }
      }

      .more_link {
        font-family: medium;
        text-align: left;
        padding: 0;
        color: #1D2087;
        font-size: 2.4rem;
        cursor: pointer;
        border-bottom: 1px solid #707070;
        padding: 0 0 0.5rem 0;
      }
    }
  }

  .right_content {
    max-width: 98.7rem;
    flex: 1;

    .image_display {
      position: relative;
      width: 100%;
      height: 50rem;
      overflow: visible;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .hotspot {
        position: absolute;
        cursor: pointer;
        z-index: 10;

        .hotspot_dot {
          width: 2rem;
          height: 3rem;
          object-fit: contain;
          animation: pulse 2s infinite;
        }

        .hotspot_popup {
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: 1rem;
          //background: white;
          //border-radius: 0.8rem;
          //box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);
          padding: 1.5rem;
          min-width: 20rem;
          width: fit-content;
          z-index: 100;
          cursor: pointer;
          transition: transform 0.2s;
          display: flex;
          flex-direction: column;
          align-items: center;

          &:hover {
            transform: translateX(-50%) scale(1.05);
          }

          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border: 0.8rem solid transparent;
            border-top-color: white;
          }

          .popup_image {
            width: 15rem;
            height: 12rem;
            object-fit: contain;
            padding: 1rem;
            border-radius: 1.6rem;
            margin-bottom: 1rem;
            background: #e0e0e0;
            box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);
          }

          .popup_text {
            width: fit-content;
            font-size: 1.8rem;
            color: white;
            margin: 0;
            text-align: center;
            line-height: 1.6;
            font-family: medium;
            background: $textMainColor;
            border-radius: 3rem;
            padding: 0.5rem 1rem 0.2rem;
            white-space: nowrap;
          }
        }
      }
    }
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.8;
    }
  }

  .contacts_section {
    background: linear-gradient(135deg, #1a4d8f 0%, #2563a8 100%);
    padding: 6rem 2rem;

    h2 {
      text-align: center;
      font-size: 3.6rem;
      color: white;
      margin: 0 0 3rem;
    }

    .contact_card {
      max-width: 80rem;
      margin: 0 auto;
      background: white;
      border-radius: 1rem;
      padding: 4rem;

      .card_title {
        font-size: 2rem;
        color: $color2C;
        margin: 0 0 3rem;
        text-align: center;
      }

      .contact_info {
        display: flex;
        justify-content: center;
        gap: 8rem;

        .info_item {
          display: flex;
          align-items: center;
          gap: 1.5rem;

          i {
            font-size: 3rem;
            color: $textBlueColor;
          }

          .label {
            font-size: 1.2rem;
            color: $color5E;
            margin: 0 0 0.5rem;
          }

          .value {
            font-size: 1.6rem;
            color: $color2C;
            margin: 0;
          }
        }
      }
    }
  }
}

@media (min-width: 2100px) {
  .solution_fttx .right_content {
    margin-left: 30rem !important;
  }
}

@media (max-width: 1200px) {
  .solution_fttx {
    .top_img {
      height: 30rem;

      .title {
        font-size: 3rem;
      }

      .subtitle {
        width: 80%;
        font-size: 1.4rem;
        line-height: 1.5;
      }
    }

    .nav_container {
      flex-direction: column;
      padding: 0;
    }

    .breadcrumb_section {
      display: none;
      width: 100%;
    }

    .page_nav_div {
      width: 100% !important;
      padding: 0 !important;
      justify-content: center !important;
      display: flex;

      p {
        padding: 0.8rem 1.2rem;
        font-size: 1.2rem;
      }
    }

    .main_content .content_wrapper {
      flex-direction: column;
    }

    .left_sidebar {
      width: 100%;
    }

    .contacts_section {
      .contact_card .contact_info {
        flex-direction: column;
        gap: 2rem;
      }
    }
  }
}

@media (max-width: 768px) {
  .solution_fttx {
    .top_img {
      padding: 0 2rem;
      height: 30rem;
      display: flex;

      .title {
        font-size: 3rem;
        margin: 5rem 0 0 0;
      }

      .subtitle {
        width: 80%;
        font-size: 1.4rem;
        margin-top: 1rem;
        line-height: 1.5;

      }
    }

    .nav_container {
      padding: 0;
      display: flex;
    }

    .breadcrumb_section {
      padding: 2rem 0 0;
    }

    .main_content {
      padding: 8rem 0 15rem;

      .section_title {
        font-size: 3rem;
        margin: 0 0 4rem 0;
        padding-left: 2rem;
      }

      .content_wrapper {
        margin: 0 2rem;
        display: flex;
        flex-direction: column-reverse;
      }
    }

    .left_sidebar {
      .product_title {
        font-size: 2rem;
      }

      .product_list {
        .product_item {
          .item_content {
            .sub_item {

              .sub_img {
                width: 8rem;
                height: 8rem;
              }

              .sub_info {
                .sub_name {
                  font-size: 1.6rem;
                }

                .view_btn {
                  font-size: 1.4rem;
                }
              }

            }
          }
        }

        .more_link {
          font-size: 2rem;
        }

      }

    }

    .right_content {
      .image_display {
        height: 22rem;

        .hotspot {
          .hotspot_dot {
            width: 1rem;
            height: 2rem;
          }
        }
      }
    }
  }
}
</style>
